<script>
import DaysList from '../form-components/DaysList.vue'
import simplebar from "simplebar-vue";
import Label from '../form-components/Label.vue';
import Multiselect from "vue-multiselect";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    listData: {
      type: Array,
      required: true
    },
    selectedItem: {
      type: Object,
      required: true
    },
    prevSelectedItem: {
      type: String,
      required: true
    },
    setSelectedItems: {
      type: Function,
      required: false
    },
    topbarControls: {
      type: Object,
      required: false
    }
  },
  components: {
    DaysList,
    simplebar, Label,
    Multiselect
  },
  data(){
    return {
      value: null,
      prev_value: null,
      label: {
        label: 'Select Location',
        placeholder: 'Select Location'
      }
    }
  },
  computed: {
    totalItems() {
      return this.filteredList.length;
    },
    totalActiveItems() {
      return this.filteredList.length;
    },
    filteredList() {
      if(this.value) {
        let list = this.value.additionalProp1.regular_hours;
        for(let itm of list) {
          Object.assign(itm, {location_id: this.value.id})
        }
        if(list && list.length) {
          if(!list.filter(x => x.id == this.selectedItem.id).length) {
            this.setSelectedItems(list[0]);
          }
          return list;
        }
        else {
            this.setSelectedItems({});
            return [];
        }
      }
      else return [];
    }
  },
  watch: {
    value: {
      handler(val) {
        if(val && val.id != this.prev_value) {
          this.prev_value = val.id
          let list = val.additionalProp1.regular_hours;
          if(list && list.length) {
            this.setSelectedItems(list[0]);
          }
        }
      },
      deep: true
    }
  },
  methods: {
  },
};
</script>
<template>
  <div v-if="listData.length">
    <simplebar class="simplebar-custom"
    id="scrollElement"
    data-simplebar-auto-hide="false"
  >
    <div>
      <Label :item="label"/>
      <Multiselect
        track-by="title"
        label="title"
        v-model="value"
        :options="listData"
        :searchable="listData.length > 5 ? true : false"
        :close-on-select="true"
        :show-labels="false"
        :placeholder="'Select Location'"
        :allow-empty="false"
        :preselectFirst="true"
        open-direction="bottom"
      >
        <template slot="singleLabel" slot-scope="{ option }"
          ><strong>{{ option.title }}</strong></template
        >
      </Multiselect>
    </div>
    <Label v-if="!item.empty" :item="item" :total_items="totalItems" :total_active_items="totalActiveItems"/>
    <DaysList v-if="item.draggable" :variant="item.variant" :list="filteredList" :selectedItem="selectedItem"
    :setSelectedItems="setSelectedItems" :prevSelectedItem="prevSelectedItem" :topbarControls="topbarControls"
    />  
    </simplebar>
  </div>
  <div v-else></div>
</template>

<style scoped>
 .simplebar-custom {
   max-height: calc(100vh - 300px);
   padding-right: 2em;
 }
</style>